// extracted by mini-css-extract-plugin
module.exports = {"confirmationText":"ConfirmModal_confirmationText__3_9AL","buttonWrapper":"ConfirmModal_buttonWrapper__DbQcE","cancel":"ConfirmModal_cancel__2ugR3"};